import { useParams } from 'react-router-dom'

import EditTemplateWeek from 'modules/shift_management/components/Settings/ShiftTemplates/Content/EditTemplateWeek'

const EditTemplateWeekPage = () => {
  const { shiftTemplateId, weekId } = useParams()

  return <EditTemplateWeek shiftTemplateId={Number(shiftTemplateId)} weekId={Number(weekId)} />
}

export default EditTemplateWeekPage
